/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: Add Unsubsubscribe
import { FC } from 'react';
import {
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuGroup,
  MenuItem,
  useMediaQuery,
  Button
} from '@chakra-ui/react';
import { BsEyeFill, BsThreeDotsVertical } from 'react-icons/bs';
import { CrucibleLock, RewardProgram } from 'types';
import { useRewardPrograms } from 'store/zustand/useRewardPrograms';
import { useWeb3React } from 'hooks/web3';
import { useModal } from 'store/modals';

type Props = {
  lock: CrucibleLock;
  rewardProgram: RewardProgram;
  crucibleId: string;
  isReadOnly?: boolean;
  setTabIndex: (index: number) => void;
};

const LockedAssetsAction: FC<Props> = ({
  lock,
  rewardProgram,
  crucibleId,
  isReadOnly,
  setTabIndex
}) => {
  const { chainId = 1 } = useWeb3React();
  const { setCurrentRewardProgram } = useRewardPrograms();
  const { openModal } = useModal();
  const [isLargerThan768] = useMediaQuery('(min-width: 769px)');

  const handleView = (rewardProgram: RewardProgram) => {
    setCurrentRewardProgram(chainId, rewardProgram);
    isReadOnly ? setTabIndex(1) : setTabIndex(2);
  };

  // TODO: Issue getting rewardProgramTokens
  // const handleUnsubscribe = async (rewardProgram: RewardProgram) => {
  //   setCurrentRewardProgram(chainId, rewardProgram.address);
  //   getSubscriptionsForCrucible(crucibleId, rewardProgram, rewardProgramTokens);

  //   openModal(ModalType.claimRewards, {
  //     crucibleId,
  //     subscriptionIdx: 0,
  //   });
  // };

  return (
    <Menu>
      {isLargerThan768 ? (
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<BsThreeDotsVertical />}
          variant='ghost'
        />
      ) : (
        <MenuButton as={Button} variant='outline'>
          Actions
        </MenuButton>
      )}
      <MenuList zIndex={4}>
        <MenuGroup
          textAlign='left'
          color='white'
          title={
            isReadOnly
              ? `
            ${lock.subscriptionCount} ${rewardProgram?.name}  subscription${
                  lock.subscriptionCount > 1 ? 's' : ''
                }`
              : `You have ${lock.subscriptionCount} ${
                  rewardProgram?.name
                }  subscription${lock.subscriptionCount > 1 ? 's' : ''}`
          }
        >
          <MenuItem
            icon={<BsEyeFill />}
            color='white'
            onClick={() => handleView(rewardProgram)}
          >
            View {rewardProgram?.name} rewards
          </MenuItem>
          {/* <MenuItem
            isDisabled={
              subscriptionsLoading || crucibleAssetsStatus === STATUS.UPDATING
            }
            icon={<BsUnlock />}
            color='white'
            onClick={() => handleUnsubscribe(rewardProgram)}
          >
            Unsubscribe & Claim
            {(subscriptionsLoading ||
              crucibleAssetsStatus === STATUS.UPDATING) && (
              <Spinner size='sm' />
            )}
          </MenuItem> */}
        </MenuGroup>
      </MenuList>
    </Menu>
  );
};

export default LockedAssetsAction;
